module.exports = __webpack_public_path__ + "static/img/zhinengzhizao-1.f5925381.svg";